export default [
  {
    path: "/user/domains",
    name: "UserDomain",
    component: () => import("@/views/Ondemand/Domains.vue"),
  },
];
